import axios from 'axios';

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createRoot, hydrateRoot } from 'react-dom/client';

import '../../css/app.css'; // Import the Tailwind CSS
import '../../sass/front-react/base/index.scss'; // Import the custom CSS

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

createInertiaApp({
    title: (title: string) => `${title} - ${appName}`,
    resolve: (name: string) =>
        resolvePageComponent(
            `./pages/${name}.tsx`,
            import.meta.glob('./pages/**/*.tsx'),
        ),
    setup({ el, App, props }: { el: HTMLElement; App: React.FC; props: any }) {
        if (import.meta.env.SSR) {
            hydrateRoot(
                el,
                <>
                    <App {...props} />
                </>,
            );
            return;
        }

        createRoot(el).render(
            <>
                <App {...props} />
            </>,
        );
    },
    progress: {
        color: '#4fc1b1',
    },
}).then(() => {
    console.log('Inertia app initialized.');
});
